import React from "react";
import {
  Stack,
  Typography,
  styled,
  IconButton,
  Button,
  Tooltip,
  TooltipProps,
  tooltipClasses
} from "@mui/material";

const Card = styled(Stack)(() => ({
  "& .button": {
    height: "40px",
    padding: "5px 10px",
    fontSize: "12px",
    fontWeight: 400
  },
  "& .icon-button": {
    background: "none",
    width: "fit-content",
    height: "fit-content",
    padding: 0
  },
  "& .ellipses-button": {
    backgroundColor: "#00000066",
    borderRadius: 13,
    height: 36,
    width: 43,
    "&:hover": {
      backgroundColor: "#00000066"
    }
  }
}));

const CustomTooltip = styled(({ className, ...props }: TooltipProps) =>
  <Tooltip {...props} classes={{ popper: className }} />
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontSize: 10,
    fontWeight: 500,
    padding: theme.spacing(1)
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black
  }
}));

const StyledIconButton = styled(IconButton)(({ theme }: any) => ({
  padding: theme.spacing(0.7),
  background: theme.palette.common.white,
  boxShadow: "0px 0.866667px 3.46667px rgb(0 0 0 / 25%)",
  borderRadius: 9,
  width: 36,
  height: 31,
  "& .far": {
    fontSize: 12
  }
}));

const StyledButton = styled(Button)(({ theme }: any) => ({
  padding: `${theme.spacing(0.7)} ${theme.spacing(1.5)}`,
  boxShadow: "0px 0.866667px 3.46667px rgb(0 0 0 / 25%)",
  borderRadius: 9,
  fontSize: 12,
  fontWeight: 500,
  height: 31,
  "& .far": {
    fontSize: 12
  }
}));

export interface EventDetailCardInterface {
  eventName: string;
  days?: number;
  onShare: () => void;
  categories?: string[];
  onDetail: () => void;
  onInterest: () => void;
  height?: number;
}

const EventDetailCard = ({
  eventName,
  days,
  onShare,
  onDetail,
  onInterest,
  categories,
  height
}: EventDetailCardInterface) => {
  return (
    <Card pt={3} px={2} height={height || 380}>
      <Stack spacing={2.5} flex={1}>
        <Typography
          variant="h4"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "inherit",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical"
          }}
        >
          {eventName}
        </Typography>
        <Stack spacing={1}>
          <Typography className="font-grey" variant="h5" fontWeight={400}>
            Categories
          </Typography>
          <Stack direction="row" spacing={2} alignItems="center">
            <Stack
              flex={1}
              className="border-1-primary"
              p={1.5}
              borderRadius={1}
            >
              <Typography
                className="font-grey"
                variant="h6"
                fontWeight={400}
                style={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  maxWidth: 180,
                  whiteSpace: "nowrap"
                }}
              >
                {categories && categories.length > 0
                  ? categories.join(",")
                  : "No categories defined"}
              </Typography>
            </Stack>
            <CustomTooltip
              title={categories ? categories.join(",") : undefined}
              arrow
              placement="top"
            >
              <IconButton className="ellipses-button">
                <i
                  className="fas fa-ellipsis-h font-white"
                  style={{ fontSize: "10px" }}
                />
              </IconButton>
            </CustomTooltip>
          </Stack>
        </Stack>
      </Stack>
      <Stack spacing={5} pb={3}>
        <Stack spacing={1} direction="row" alignItems="center">
          <Stack
            className="background-primary"
            borderRadius={2.5}
            width={43}
            height={36}
            alignItems="center"
            justifyContent="center"
          >
            <Typography className="font-white" variant="h4" fontWeight={500}>
              {days}
            </Typography>
          </Stack>
          <Typography className="font-grey" variant="h4" fontWeight={500}>
            day(s) left until start
          </Typography>
        </Stack>
        <Stack direction="row">
          <Stack direction="row" spacing={1} alignItems="center" flex={1}>
            <StyledIconButton onClick={onShare}>
              <i className="far fa-share-alt font-black" />
            </StyledIconButton>
            <StyledButton
              startIcon={<i className="far fa-star font-black" />}
              variant="text"
              onClick={onInterest}
              className="font-black background-white"
            >
              Interested
            </StyledButton>
            <IconButton className="icon-button">
              <i
                className="fal fa-calendar font-black"
                style={{ fontSize: 12 }}
              />
            </IconButton>
          </Stack>
          <StyledButton variant="contained" color="primary" onClick={onDetail}>
            Details
          </StyledButton>
        </Stack>
      </Stack>
      <Stack className="background-primary" height={5} width="100%" />
    </Card>
  );
};
export default EventDetailCard;
